export { DSTabs, DSTabsWithSchema } from './DSTabs.js';
export type { DSTabT, DSTabsT } from './react-desc-prop-types.js';
export {
  TABS_SLOTS,
  TABS_DATA_TESTID,
  TABS_DATA_TESTID as DSTabsDatatestid,
  TAB_TYPES,
  TAB_TYPES as TabTypes,
  DSTabsName,
} from './constants/index.js';
export { DSTab, DSTabWithSchema } from './exported-related/DSTab.js';
